/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_PoorInputs */

const en_val_poor = /** @type {(inputs: Val_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poor`)
};

const es_val_poor = /** @type {(inputs: Val_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malo`)
};

const fr_val_poor = /** @type {(inputs: Val_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médiocre`)
};

const de_val_poor = /** @type {(inputs: Val_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlecht`)
};

const ja_val_poor = /** @type {(inputs: Val_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`悪い`)
};

const zh_val_poor = /** @type {(inputs: Val_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`较差`)
};

const ar_val_poor = /** @type {(inputs: Val_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ضعيف`)
};

const id_val_poor = /** @type {(inputs: Val_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buruk`)
};

const it_val_poor = /** @type {(inputs: Val_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scadente`)
};

const ru_val_poor = /** @type {(inputs: Val_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Плохое`)
};

const pt_val_poor = /** @type {(inputs: Val_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruim`)
};

const ko_val_poor = /** @type {(inputs: Val_PoorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나쁨`)
};

/**
* | output |
* | --- |
* | "Poor" |
*
* @param {Val_PoorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_poor = /** @type {((inputs?: Val_PoorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_PoorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_poor(inputs)
	if (locale === "es") return es_val_poor(inputs)
	if (locale === "fr") return fr_val_poor(inputs)
	if (locale === "de") return de_val_poor(inputs)
	if (locale === "ja") return ja_val_poor(inputs)
	if (locale === "zh") return zh_val_poor(inputs)
	if (locale === "ar") return ar_val_poor(inputs)
	if (locale === "id") return id_val_poor(inputs)
	if (locale === "it") return it_val_poor(inputs)
	if (locale === "ru") return ru_val_poor(inputs)
	if (locale === "pt") return pt_val_poor(inputs)
	return ko_val_poor(inputs)
});